// extracted by mini-css-extract-plugin
module.exports = {"text-input":"text-input_text-input__vAVLV","text-input__input":"text-input_text-input__input__TLQXu"};